'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppDocumentDataCreditNoteForm(number, recipient, issueDate, invoiceNumber, invoiceDate, lineItems, originOfGoods, documentaryCredit, currency, placeOfReceipt, placeOfLoading, placeOfDelivery, placeOfDischarge, incoterm, extraCredit, purchaseOrderReference, transportDocumentNumber) {
  this.gV = null;
  this.gW = null;
  this.gT = null;
  this.ha = null;
  this.gS = null;
  this.gU = null;
  this.hb = null;
  this.h8 = null;
  this.gQ = null;
  this.hf = null;
  this.he = null;
  this.hc = null;
  this.hd = null;
  this.h9 = null;
  this.gR = null;
  this.hg = null;
  this.hh = null;
  this.gV = number;
  this.gW = recipient;
  this.gT = issueDate;
  this.ha = invoiceNumber;
  this.gS = invoiceDate;
  this.gU = lineItems;
  this.hb = originOfGoods;
  this.h8 = documentaryCredit;
  this.gQ = currency;
  this.hf = placeOfReceipt;
  this.he = placeOfLoading;
  this.hc = placeOfDelivery;
  this.hd = placeOfDischarge;
  this.h9 = incoterm;
  this.gR = extraCredit;
  this.hg = purchaseOrderReference;
  this.hh = transportDocumentNumber;
}
export { $c_Lapp_data_AppDocumentDataCreditNoteForm as $c_Lapp_data_AppDocumentDataCreditNoteForm };
$p = $c_Lapp_data_AppDocumentDataCreditNoteForm.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppDocumentDataCreditNoteForm;
/** @constructor */
function $h_Lapp_data_AppDocumentDataCreditNoteForm() {
}
export { $h_Lapp_data_AppDocumentDataCreditNoteForm as $h_Lapp_data_AppDocumentDataCreditNoteForm };
$h_Lapp_data_AppDocumentDataCreditNoteForm.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_AppDocumentDataCreditNoteForm)) {
    if ((this.gV === x$0.gV)) {
      var x = this.gW;
      var x$2 = x$0.gW;
      var $x_14 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_14 = false;
    }
    if ($x_14) {
      var x$3 = this.gT;
      var x$4 = x$0.gT;
      var $x_13 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_13 = false;
    }
    if (($x_13 && (this.ha === x$0.ha))) {
      var x$5 = this.gS;
      var x$6 = x$0.gS;
      var $x_12 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_12 = false;
    }
    if ($x_12) {
      var x$7 = this.gU;
      var x$8 = x$0.gU;
      var $x_11 = ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      var $x_11 = false;
    }
    if ($x_11) {
      var x$9 = this.hb;
      var x$10 = x$0.hb;
      var $x_10 = ((x$9 === null) ? (x$10 === null) : x$9.f(x$10));
    } else {
      var $x_10 = false;
    }
    if ($x_10) {
      var x$11 = this.h8;
      var x$12 = x$0.h8;
      var $x_9 = ((x$11 === null) ? (x$12 === null) : x$11.f(x$12));
    } else {
      var $x_9 = false;
    }
    if ($x_9) {
      var x$13 = this.gQ;
      var x$14 = x$0.gQ;
      var $x_8 = ((x$13 === null) ? (x$14 === null) : x$13.f(x$14));
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$15 = this.hf;
      var x$16 = x$0.hf;
      var $x_7 = ((x$15 === null) ? (x$16 === null) : x$15.f(x$16));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$17 = this.he;
      var x$18 = x$0.he;
      var $x_6 = ((x$17 === null) ? (x$18 === null) : x$17.f(x$18));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$19 = this.hc;
      var x$20 = x$0.hc;
      var $x_5 = ((x$19 === null) ? (x$20 === null) : x$19.f(x$20));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$21 = this.hd;
      var x$22 = x$0.hd;
      var $x_4 = ((x$21 === null) ? (x$22 === null) : x$21.f(x$22));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$23 = this.h9;
      var x$24 = x$0.h9;
      var $x_3 = ((x$23 === null) ? (x$24 === null) : x$23.f(x$24));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$25 = this.gR;
      var x$26 = x$0.gR;
      var $x_2 = ((x$25 === null) ? (x$26 === null) : x$25.f(x$26));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$27 = this.hg;
      var x$28 = x$0.hg;
      var $x_1 = ((x$27 === null) ? (x$28 === null) : x$27.f(x$28));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$29 = this.hh;
      var x$30 = x$0.hh;
      return ((x$29 === null) ? (x$30 === null) : x$29.f(x$30));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 17;
});
$p.t = (function() {
  return "AppDocumentDataCreditNoteForm";
});
$p.e = (function(n) {
  switch (n) {
    case 0: {
      return this.gV;
      break;
    }
    case 1: {
      return this.gW;
      break;
    }
    case 2: {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_FrameworkDate(this.gT);
      break;
    }
    case 3: {
      return this.ha;
      break;
    }
    case 4: {
      return this.gS;
      break;
    }
    case 5: {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcats_data_NonEmptyVector(this.gU);
      break;
    }
    case 6: {
      return this.hb;
      break;
    }
    case 7: {
      return this.h8;
      break;
    }
    case 8: {
      return this.gQ;
      break;
    }
    case 9: {
      return this.hf;
      break;
    }
    case 10: {
      return this.he;
      break;
    }
    case 11: {
      return this.hc;
      break;
    }
    case 12: {
      return this.hd;
      break;
    }
    case 13: {
      return this.h9;
      break;
    }
    case 14: {
      return this.gR;
      break;
    }
    case 15: {
      return this.hg;
      break;
    }
    case 16: {
      return this.hh;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.u = (function(n) {
  switch (n) {
    case 0: {
      return "number";
      break;
    }
    case 1: {
      return "recipient";
      break;
    }
    case 2: {
      return "issueDate";
      break;
    }
    case 3: {
      return "invoiceNumber";
      break;
    }
    case 4: {
      return "invoiceDate";
      break;
    }
    case 5: {
      return "lineItems";
      break;
    }
    case 6: {
      return "originOfGoods";
      break;
    }
    case 7: {
      return "documentaryCredit";
      break;
    }
    case 8: {
      return "currency";
      break;
    }
    case 9: {
      return "placeOfReceipt";
      break;
    }
    case 10: {
      return "placeOfLoading";
      break;
    }
    case 11: {
      return "placeOfDelivery";
      break;
    }
    case 12: {
      return "placeOfDischarge";
      break;
    }
    case 13: {
      return "incoterm";
      break;
    }
    case 14: {
      return "extraCredit";
      break;
    }
    case 15: {
      return "purchaseOrderReference";
      break;
    }
    case 16: {
      return "transportDocumentNumber";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lapp_data_AppDocumentDataCreditNoteForm(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iT)));
}
export { $isArrayOf_Lapp_data_AppDocumentDataCreditNoteForm as $isArrayOf_Lapp_data_AppDocumentDataCreditNoteForm };
var $d_Lapp_data_AppDocumentDataCreditNoteForm = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentDataCreditNoteForm, "app.data.AppDocumentDataCreditNoteForm", ({
  iT: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_AppDocumentDataCreditNoteForm as $d_Lapp_data_AppDocumentDataCreditNoteForm };
//# sourceMappingURL=app.data.-App-Document-Data-Credit-Note-Form.js.map
